import type { RovoApp } from '../../controllers/chat-mode-store/types';

import { is3pApp } from './is-3p-app';

export type ConnectorForRovoApp = {
	source: string;
	friendlyName: string;
	iconUrl: string;
	isUserOAuthed?: boolean;
	connectedAt?: string | null;
};

/**
 * Builds a list of RovoApp from connectors: third-party apps first (by connectedAt desc),
 * then first-party apps (by connectedAt desc), only including OAuthed connectors.
 */
export function getAllConnectedApps(connectors: Record<string, ConnectorForRovoApp>): RovoApp[] {
	const toMs = (c: ConnectorForRovoApp) => (c.connectedAt ? new Date(c.connectedAt).getTime() : 0);
	const authedConnectors = Object.values(connectors).filter((c) => c.isUserOAuthed);
	const thirdPartyApps = authedConnectors
		.filter((c) => is3pApp(c.friendlyName))
		.sort((a, b) => toMs(b) - toMs(a));
	const firstPartyApps = authedConnectors
		.filter((c) => !is3pApp(c.friendlyName))
		.sort((a, b) => toMs(b) - toMs(a));

	return [...thirdPartyApps, ...firstPartyApps].map((c) => ({
		source: c.source,
		friendlyName: c.friendlyName,
		iconUrl: c.iconUrl,
	}));
}
